import React, { useEffect, useState } from 'react'
import { ListChecks } from '@phosphor-icons/react'
import { useSidePanel } from '@/lib/context/sidePanelContext'

type Props = {
  onClick: () => void
}

export const ApplyRulesButton: React.FC<Props> = ({ onClick }) => {
  const { isOpen, closeCounter } = useSidePanel()
  const [active, setActive] = useState(false)

  const handleClick = () => {
    setActive(prev => !prev)
    onClick()
  }

  useEffect(() => {
    if (!isOpen) {
      setActive(false)
    }
  }, [isOpen])

  useEffect(() => {
    if (typeof closeCounter === 'number' && closeCounter > 0) {
      setActive(false)
    }
  }, [closeCounter])

  return (
    <button
      type='button'
      onClick={handleClick}
      className={`flex w-36 items-center justify-center gap-2 self-stretch border-l border-gray-200 text-center font-semibold transition-colors ${
        active ? `rounded-md bg-blue-500 text-white` : `text-blue-500`
      }`}
    >
      <ListChecks size={24} className='scale-x-[-1]' />
      Choose Rule
    </button>
  )
}

export default ApplyRulesButton
